import { useState, useEffect } from "react";
import Logo from "./LogoComponent";
import { Tabs, ConfigProvider, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import LanguageComponent from "./LanguageComponent";
import styled from "styled-components";
import "../styles/HeaderComponent.css";

const StyledTabs = styled(Tabs)`
  .ant-tabs-tab { position: relative; }
  .ant-tabs-tab-btn { text-shadow: 0 0 8px rgba(0,0,0,0.8); }
  .ant-tabs-tab:hover::after {
    content: "";
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #45ff95;
    border-radius: 2px;
    position: absolute;
  }
`;

const HeaderComponent = ({tabLabels, currentLanguage, onLanguageChange}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const [drawerVisible, setDrawerVisible] = useState(false);

  const tabItems = tabLabels.map((item, index) => ({
    label: item.label,
    key: (index + 1).toString(),
    id: item.id,
  }));

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 2;
      for (let i = tabItems.length - 1; i >= 0; i--) {
        const section = document.getElementById(tabItems[i].id);
        if (section && section.offsetTop <= scrollPos) {
          setActiveKey(tabItems[i].key);
          break;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [tabItems]);

  const handleTabChange = (key) => {
    setActiveKey(key);
    setDrawerVisible(false);
    const sectionId = tabItems[key - 1]?.id;
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="row" id="header" style={{ paddingTop: 15, alignItems: "center", backgroundColor:"black", boxShadow: "0px 25px 25px rgba(0, 0, 0)" }}>
      <div className="col-4 col-md-2">
        <Logo />
      </div>
      <div className="col-4 col-md-8" style={{ textAlign: "right" }}>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemSelectedColor: "#45afff",
                inkBarColor: "#45afff",
                itemHoverColor: "#45ff95",
                itemColor: "#FFFFFF",
                itemActiveColor: "#45ff95",
              },
            },
          }}
        >
          {isMobile ? (
            <>
              <Button
                type="text"
                icon={<MenuOutlined style={{ fontSize: 24, color: "#fff" }} />}
                onClick={() => setDrawerVisible(true)}
              />
              <Drawer
                placement="right"
                closable
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
                bodyStyle={{
                  backgroundColor: "black",
                }}
              >
                <div className="drawer-menu">
                  {tabItems.map((tab) => (
                    <div
                      key={tab.key}
                      className={`drawer-tab ${activeKey === tab.key ? "active-tab" : ""}`}
                      onClick={() => handleTabChange(tab.key)}
                    >
                      {tab.label}
                    </div>
                  ))}
                </div>
              </Drawer>
            </>
          ) : (
            <StyledTabs
              className="custom-tabs"
              activeKey={activeKey}
              onChange={handleTabChange}
              centered
              items={tabItems}
            />
          )}
        </ConfigProvider>
       
      </div>
      <div className="col-4 col-md-2 text-center">
        <LanguageComponent currentLanguage={currentLanguage} onLanguageChange={onLanguageChange}/>
      </div>
    </div>
  );
};

export default HeaderComponent;
